import { SxProps } from '@mui/material'

import theme from '../../../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%'
  } as SxProps,

  stepsListContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1.25),
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    padding: theme.spacing(0.5, 2),
    overflow: 'visible'
  } as SxProps,

  stepContainer: {
    display: 'flex',
    gap: theme.spacing(1.75),
    padding: theme.spacing(1.5, 0),
    overflow: 'visible'
  } as SxProps,

  stepIndicatorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  } as SxProps,

  stepNumberCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    flexShrink: 0
  } as SxProps,

  stepNumberText: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: '#FFFFFF'
  } as SxProps,

  stepConnector: {
    width: 2,
    flex: 1,
    minHeight: theme.spacing(3),
    backgroundColor: '#E5E7EB',
    marginTop: 0,
    marginBottom: -theme.spacing(3),
    flexShrink: 0
  } as SxProps,

  stepContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    paddingTop: theme.spacing(0.25)
  } as SxProps,

  stepTitleText: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.grey[800]
  } as SxProps,

  stepDescriptionText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[400],
    lineHeight: 1.4
  } as SxProps,

  stepActionBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    width: '100%'
  } as SxProps,

  downloadButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.25),
    width: '100%',
    padding: theme.spacing(1.75, 2),
    borderRadius: theme.spacing(1.25),
    background: 'linear-gradient(135deg, #F5F3FF 0%, #EDE9FE 100%)',
    border: '1px solid #DDD6FE',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85
    }
  } as SxProps,

  downloadIcon: {
    color: theme.palette.primary.main,
    fontSize: 18
  } as SxProps,

  downloadText: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.primary.main
  } as SxProps,

  downloadButtonDisabled: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.25),
    width: '100%',
    padding: theme.spacing(1.75, 2),
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.grey[200],
    border: `1px solid ${theme.palette.grey[300]}`,
    cursor: 'not-allowed',
    opacity: 0.7
  } as SxProps,

  downloadIconDisabled: {
    color: theme.palette.grey[500],
    fontSize: 18
  } as SxProps,

  downloadTextDisabled: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.grey[500]
  } as SxProps,

  labelHintText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[400]
  } as SxProps,

  locationCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.25),
    borderRadius: theme.spacing(1.25),
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    padding: theme.spacing(2)
  } as SxProps,

  locationNameText: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps,

  locationAddressText: {
    fontSize: '0.8125rem',
    color: theme.palette.grey[500],
    lineHeight: 1.5,
    whiteSpace: 'pre-line'
  } as SxProps,

  locationMetaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75)
  } as SxProps,

  locationMetaIcon: {
    fontSize: 14,
    color: theme.palette.grey[400]
  } as SxProps,

  locationMetaText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[400]
  } as SxProps,

  directionsIcon: {
    fontSize: 14,
    color: theme.palette.primary.main
  } as SxProps,

  directionsLinkText: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  } as SxProps
}

export default styles
